import { render, staticRenderFns } from "./ReferralInput.vue?vue&type=template&id=31699f32&"
import script from "./ReferralInput.vue?vue&type=script&lang=js&"
export * from "./ReferralInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports